export default "__VITE_ASSET__9aa4f9b0__"